
import { CommonModule } from '@angular/common';
import { ViewChild, ElementRef, AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { CandidateService } from 'src/app/services/CandidateService';
import { candidateModel } from 'src/app/services/candidateModel';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { JobCandidate } from 'src/app/services/jobModel';
import Swal from 'sweetalert2';
import { AppSettings } from './../../../services/AppSettings';
import { GigsumoConstants } from './../../../services/GigsumoConstants';
import { ApiService } from './../../../services/api.service';
import { SearchData } from './../../../services/searchData';
import { UtilService } from './../../../services/util.service';
import { JobCardComponent } from '../../cards/job-card/job-card.component';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-candidate-job-invite',
  standalone: true,
  imports: [CommonModule, JobCardComponent, CommonSkeletonComponent,
InfiniteScrollModule,
    NG_ICON_DIRECTIVES,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './candidate-job-invite.component.html',
  styleUrls: ['./candidate-job-invite.component.scss'],
  inputs: ['candidateDetails', 'designVersion']
})

export class CandidateJobInviteComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  // Subscription lifetime for untracked API calls (findbyList, list reload,
  // stage update). Existing `emptySelector` + `filterSubscriber` are
  // explicitly unsubscribed below and left unchanged. Emit + complete in
  // the existing ngOnDestroy body.
  private destroy$ = new Subject<void>();

  readonly GigsumoConstants = GigsumoConstants;
  emptySelector: Subscription
  candidateId: any;
  designVersion: string;
  candidateDetails: candidateModel;
  previousValue_candidateDetails: candidateModel;
  candidateJobModel: JobCandidate;
  @Input() clickedJobIdIntraction:string;

  colorLists: any;
  candidateSeletedFilter;
  jobInvitesStatusList: any = [];
  queryParamData: any;
  entitySent: any = { entity: 'job invites' };
  searchConfig: any = {
    pageNumber: 0,
  }
  responseReceived: boolean = false;
  jobInvitedFoundStatus = "Fetching job invites.."
  invitedCandidateDetails : candidateModel;
  countss = -1;
  filterSubscriber: Subscription;
  isFilterOpen: boolean = false;
  panel: string;
  jobId: string;
  filterApplicantData: any;
  jobStatusList: { itemId: any; value: any; }[];
  tempStatusList: any;
  constructor(private api: ApiService, private searchdata: SearchData, private searchData: SearchData,
     private util: UtilService, private a_route: ActivatedRoute,
     private candidateService : CandidateService, private gigsumoService: GigsumoService, private jobService: JobService) {
    this.colorLists = this.gigsumoService.colorClass
    this.emptySelector = this.searchData.getEmptySelectors().subscribe(res => {
      if (res == true) {
        this.viewedList.forEach(element => {
          element.isSelected = false
        });
      }
    })
    this.filterSubscriber = this.jobService.getSliderToggle().subscribe(value => {
      this.panel = value.panel;
      if (value.panel == 'job invites') {

        if(!value.value) {
          if(value.filterData != null) {
            this.onFilterToggle(value.filterData);
          }
        }

        if (value.value == true  && !this.isFilterOpen) {
          this.openFilterSlider();
        } else {
          this.isFilterOpen = false;
          this.closeFilterSlider();
        }
      }
    })
  }


  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => this.setupScrollObserver());
    if(changes.candidateDetails.currentValue){
      this.searchConfig.pageNumber = 0;
      this.viewedList = [];
      this.loadAPIcall=true;
      this.stopscrollFlag = false;
      // Invalidate any in-flight page fetch — a tab re-click during
      // pagination must not append the stale page into the reset list.
      this.fetchGeneration++;
      this.candidateDetails = changes.candidateDetails.currentValue;
      this.previousValue_candidateDetails = changes.candidateDetails.previousValue;
           this.getAppliedFilter();
    }
    if( changes.clickedJobIdIntraction && changes.clickedJobIdIntraction.currentValue!=undefined){
      this.jobId = changes.clickedJobIdIntraction.currentValue;
    }else{
      this.jobId =undefined;
    }
  }
  loadAPIcall:boolean=false;
  // Sentinel pagination: a page is requested only when the bottom sentinel
  // ENTERS view (the user scrolled it in). If it enters while a page is
  // already loading, the trigger is remembered and the observer is re-armed
  // once that page has landed (afterPageSettled), so the list never sticks
  // waiting for a scroll-up-then-down — and it never chains pages on its own
  // (no scroll listener: momentum scroll events must not count as new scrolls).
  private pendingSentinelTrigger = false;
  private afterPageSettled(): void {
    if (!this.pendingSentinelTrigger) return;
    this.pendingSentinelTrigger = false;
    setTimeout(() => this.setupScrollObserver());
  }

  @ViewChild('scrollSentinel') scrollSentinel: ElementRef;
  private intersectionObserver: IntersectionObserver | null = null;

  ngAfterViewInit(): void {
    this.setupScrollObserver();
  }

  private setupScrollObserver(): void {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (!this.scrollSentinel?.nativeElement) return;
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        if (this.loadAPIcall) { this.pendingSentinelTrigger = true; return; }
        this.onScrollDown();
      },
      { root: null, rootMargin: '200px', threshold: 0 }
    );
    this.intersectionObserver.observe(this.scrollSentinel.nativeElement);
  }
  getAppliedFilter() {
    let entireInviteStatusList: any = []
    const default_invite_stages: any = GigsumoConstants.JOB_INVITES_DEFAULT_STAGES;
    this.api.create('listvalue/findbyList' , {domain : "JOB_INVITATION_SUPPLIER_ACTIONS,JOB_APPLICATION_BLOCKING_ACTIONS,JOB_INVITATION_BLOCKED_ACTIONS"}).pipe(takeUntil(this.destroy$)).subscribe(res=>{
      const sorted : Array<any> =  res.data.JOB_INVITATION_SUPPLIER_ACTIONS && res.data.JOB_INVITATION_SUPPLIER_ACTIONS.listItems;
      this.filterApplicantData = res.data;
      if(sorted){
          this.jobInvitesStatusList = sorted
          .filter(x=>default_invite_stages.includes(x.itemId))
          .map(x => {
            return {itemId : x.itemId , value : x.value};
          });


          entireInviteStatusList = sorted
          .map(x => {
            return {itemId : x.itemId , value : x.value};
          });

        this.tempStatusList = entireInviteStatusList;
        this.removedData =  this.updatedArr();
        const data = sorted.map(x => {
        let d = Object.keys(this.removedData).find(c => c === x.itemId);
        return d ? x : undefined; }).filter(x => x!= undefined);
        this.filterByStatus(data.map(x => x.itemId).toString());
      }
     });
  }


  viewedList: any = []
  ngOnInit() {

    this.scrollGate.attach();
    this.loadAPIcall=true;
    this.viewedList = [];
    this.searchConfig.pageNumber = 0;
    this.scrollSubject.pipe(
      debounceTime(100),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag) return;
      const status = this.jobInvitesStatusList.map(oject => oject.itemId);
      this.getViews(status.toString(), null);
    });
  }


  openFilterSlider() {
    if (!this.isFilterOpen) {
      this.isFilterOpen = true;
      this.jobService.setDataForFilter({...this.removedData});
      this.jobService.setSliderToggle(true, 'job invites', null,false);
    }
  }

  closeFilterSlider(): void {
    if (this.isFilterOpen) {
      this.isFilterOpen = false;
      this.jobService.setSliderToggle(false, 'job invites', null,false);
    }
  }

  count: number = 0;
  getjobId(item) {
     if(item === "REFRESH"){
      this.searchConfig.pageNumber = 0;
      this.viewedList = [];
      this.getViews(this.tempStatusList.map(c=>c.itemId).toString() , null);
    }
   }




  // getting values from candidate card checkbox after i will pass to parent
  @Output() candidateSelectionChanged = new EventEmitter<any>();
  @Output() parentValueChange = new EventEmitter<any>();
   pushtoparentcomponent(selectedItem) {

    selectedItem.parentType = "CANDIDATE_INVITATION,JOB_APPLICATION";
    this.candidateSelectionChanged.emit(selectedItem);
    this.parentValueChange.emit(selectedItem)
    this.updateSelectionInList(selectedItem);

  }
  updateSelectionInList(selectedItem) {
    this.viewedList.forEach((element:any) => {

      if(selectedItem.currentStatus=='ACCEPTED'){
        element.candidateEntity.resumeAttached=true;
       }
      if(element.jobDetails.jobId == selectedItem.jobId) {
         element.jobDetails.currentStatus = selectedItem.currentStatus;
         element.jobDetails.isSelected = selectedItem.isSelected;
         element.jobDetails.activityDate = selectedItem.activityDate;
      }else{
        element.jobDetails.isSelected = false;
      }
    });

  }

  initialSelected(){

    this.viewedList.forEach((element,index) => {
      if(index === 0 && this.jobId === undefined){
        element.jobDetails.isSelected=true;
        this.pushtoparentcomponent( element.jobDetails)
      }
      else if(this.jobId === element.jobDetails.jobId){
        element.jobDetails.isSelected=true;
        this.pushtoparentcomponent( element.jobDetails)
      }

    });
  }



  public onFilterToggle(value: any) {
    const receivedData = JSON.parse(value);
    const status = receivedData ? receivedData.jobInvitesStatus : null;
    this.jobInvitesStatusList = status;

    if(status){
      const d =  this.tempStatusList.filter((e) => status.some(v => v === e.itemId));
      this.jobInvitesStatusList = d;
      this.removedData = {};
      this.jobInvitesStatusList.forEach(element => {
          this.removedData[element.itemId] =  true;
      });
    }
    this.stopscrollFlag = false
    this.viewedList = []
    this.searchConfig.pageNumber = 0;
    this.fetchGeneration++;

    this.filterByStatus(this.jobInvitesStatusList.map(c=>c.itemId).toString());
  }

  getCandidateresumecheck(value) {
    this.viewedList.forEach(element => {
      if (element.candidateEntity.candidateId == value.candidateId) {
        element.candidateEntity.resumes = value.resumes;
      }
    });
  }


  filterByStatus(status: any) {
    if(status!=""){
      this.getViews(status, null);
    }else{
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.afterPageSettled();
      this.jobInvitedFoundStatus = 'Please select appropriate filters to show relevant job invites.';
      this.returnmsgtoActivity();
    }
  }

    // message retunto activity
    returnmsgtoActivity(){
      let item :any={};
      // item.parentType="CANDIDATE_INVITATION";
      item.parentType="CANDIDATE_INVITATION,JOB_APPLICATION";
      item.tab="cInvited";
      item.data = [];
      item.responseMessage=this.jobInvitedFoundStatus;
      this.parentValueChange.emit(item)
    }

  // Stale-response gate: bumped on every list reset (tab re-click / filter
  // change). A fetch captures the value at launch; a reset mid-flight makes
  // the late response a no-op instead of appending old rows.
  private fetchGeneration = 0;
  async getViews(status, candId) {
    this.initializeResponse();
    this.updateSearchConfig(candId, status);
    const reqCandidateId = this.candidateDetails?.candidateId;
    const gen = this.fetchGeneration;
    try {
      this.loadAPIcall=true;
      const res = await this.api.create('candidates/findCandidatesInterestShownBy', this.searchConfig).toPromise();
      if (gen !== this.fetchGeneration) return;
      if (reqCandidateId !== this.candidateDetails?.candidateId) return;
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.afterPageSettled();
      this.responseReceived = true;

      if (res && res.code === '00000') {
        this.processResponseData(res);

      } else if (res.code === '99999') {
        this.jobInvitedFoundStatus = 'Something went wrong. Please, try after some time.';
      }
    } catch (err) {

    } finally {
      if (gen === this.fetchGeneration && reqCandidateId === this.candidateDetails?.candidateId) {
        this.util.stopLoader();
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.afterPageSettled();
      }
    }
  }


  initializeResponse() {
    this.responseReceived = false;
    this.countss++;
  }

  updateSearchConfig(candId, status) {
    this.searchConfig.candidateId = this.candidateDetails.candidateId;
    this.searchConfig.limit = 10;
    if (typeof status === 'string') {
      this.searchConfig.currentStatus = status.replace("SUBMITTED", "ACCEPTED");
    } else {
      this.searchConfig.currentStatus = undefined;
    }
  }



  processResponseData(res) {
    if (res.data==null||res.data.interestedShownByList.length === 0 ) {
      this.setNoJobInvitesFound();
    }else{
      if(res.data && res.data.interestedShownByList.length<9){
        this.stopscrollFlag=true;
      }else{
         this.searchConfig.pageNumber = this.searchConfig.pageNumber + 1;
         this.stopscrollFlag=false
      }
      if (res.data && res.data.interestedShownByList.length) {
        res.data.interestedShownByList.forEach((ele, index) => {
          this.processEachElement(ele, index);
        });
      }
    }
  }




  processEachElement(ele, index) {

    if (!this.viewedList.some(item => item.jobDetails.jobId === ele.jobDetails.jobId)) {
        ele.isSelected = index === 0;
        ele.jobDetails.user.photo = ele.user.photo ? AppSettings.photoUrl + ele.user.photo : null;
        ele.jobDetails.activityDate = ele.activityDate;
        ele.jobDetails.resumeUpdated = false;
        this.viewedList.push(ele);
        if (index === 0 && this.jobId === undefined) {
            this.searchdata.setJobID({ eachJob: true, jobId: ele.jobDetails.jobId });
            ele.jobDetails.firstId = true;
            this.initialSelected();
        } else if (this.jobId !== undefined && this.jobId === ele.jobDetails.jobId) {
            this.checkbasedonJobs();
        }
    } else {
        console.log('Duplicate data skipped:', ele);
    }
}
  checkbasedonJobs(){

    this.viewedList.forEach((element,index) => {
      if(this.jobId != undefined && this.jobId ==  element.jobDetails.jobId){
        element.jobDetails.isSelected=true;
        this.pushtoparentcomponent( element.jobDetails)
      }

    });
  }

  removeDuplicates(data: JobCandidate[]): JobCandidate[] {
    const seenJobIds = new Set();
    return data.filter(item => {
      const jobId = item.jobDetails.jobId;
      if (!seenJobIds.has(jobId)) {
        seenJobIds.add(jobId);
        return true;
      }
      return false;
    });
  }




  setNoJobInvitesFound() {
    this.stopscrollFlag = true;
    this.loadAPIcall = false; this.scrollGate.pageLanded();
    this.afterPageSettled();
    this.jobInvitedFoundStatus = "No job invites found.";
    this.returnmsgtoActivity();
  }




  stopscrollFlag: boolean = false
  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }




  widgetstick: boolean = false
  @HostListener("window:scroll")
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 5) {
      this.widgetstick = true;
    } else {
      this.widgetstick = false;
    }
  }

  removedData : any = [];

  updatedArr() {
    const group = {};
    let arr = [...this.jobInvitesStatusList.map(c=>c.itemId)];
    arr.forEach((element)=>{
      group[element] = true;
    });
    return group;
  }

  removeEntity(value, index) {
    this.stopscrollFlag = false
    this.viewedList = []
    this.searchConfig.pageNumber = 0
    this.fetchGeneration++;
    this.jobInvitesStatusList.splice(index, 1);
    this.removedData[value] = false;
    const status = this.jobInvitesStatusList.map(c=>c.itemId);
    this.filterByStatus(status.toString());
  }

  updatestatus(name, value) {

    this.util.startLoader();
    var data: any = {}
    data.jobId = value.jobId;
    data.candidateId = this.candidateId;
    data.currentStatus = name;
    this.api.create('candidates/updatejobAppliedStatus', data).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.util.stopLoader()
      if (res.code == '00000') {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Status successfully Updated.",
          showConfirmButton: false,
          timer: 2000,
        })
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  ngOnDestroy() {

    this.scrollGate.detach();
    this.intersectionObserver?.disconnect();
    if (this.emptySelector) {
      this.emptySelector.unsubscribe();
    }

    if (this.filterSubscriber) {
      this.filterSubscriber.unsubscribe();
    }

    // Cancel any in-flight API calls piped through destroy$
    // (findbyList, updatejobAppliedStatus).
    this.destroy$.next();
    this.destroy$.complete();
  }

}
